module.exports = __webpack_public_path__ + "img/64.497445c4.jpg";